import { render, staticRenderFns } from "./SubscriptionCardMobile.vue?vue&type=template&id=5c311198&scoped=true&"
import script from "./SubscriptionCardMobile.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCardMobile.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/subscriptionCardMobile.css?vue&type=style&index=0&id=5c311198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c311198",
  null
  
)

export default component.exports